export const UPDATE_CODES_INFO = "UPDATE_CODES_INFO";
